
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/calendar/jst/messageParticipants';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.message_groups", "Message Groups", options) : helperMissing.call(depth0, "t", "calendar.message_participants.message_groups", "Message Groups", options)))
    + "\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.message_students", "Message Students", options) : helperMissing.call(depth0, "t", "calendar.message_participants.message_students", "Message Students", options)))
    + "\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <option value=\"all\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.all_groups", "All groups", options) : helperMissing.call(depth0, "t", "calendar.message_participants.all_groups", "All groups", options)))
    + "</option>\n      <option value=\"unregistered\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.unregistered_groups", "Groups who haven't signed up yet", options) : helperMissing.call(depth0, "t", "calendar.message_participants.unregistered_groups", "Groups who haven't signed up yet", options)))
    + "</option>\n      <option value=\"registered\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.registered_groups", "Groups who have already signed up", options) : helperMissing.call(depth0, "t", "calendar.message_participants.registered_groups", "Groups who have already signed up", options)))
    + "</option>\n      ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <option value=\"all\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.all_users", "All users", options) : helperMissing.call(depth0, "t", "calendar.message_participants.all_users", "All users", options)))
    + "</option>\n      <option value=\"unregistered\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.unregistered_users", "Users who haven't signed up yet", options) : helperMissing.call(depth0, "t", "calendar.message_participants.unregistered_users", "Users who haven't signed up yet", options)))
    + "</option>\n      <option value=\"registered\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.registered_users", "Users who have already signed up", options) : helperMissing.call(depth0, "t", "calendar.message_participants.registered_users", "Users who have already signed up", options)))
    + "</option>\n      ";
  return buffer;
  }

  buffer += "<form title=\"";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.participant_type), "Group", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.participant_type), "Group", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" action='#' id='message_participants_form'>\n  <h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.send_message_to", "Send a message to...", options) : helperMissing.call(depth0, "t", "calendar.message_participants.send_message_to", "Send a message to...", options)))
    + "</h2>\n  <div>\n    <select class=\"message_groups\">\n      ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.participant_type), "Group", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.participant_type), "Group", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </select>\n  </div>\n  <ul class=\"participant_list\"></ul>\n  <div class=\"clear\"></div>\n  <div>\n    <label for=\"body\" class=\"required\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.message_participants")
  },data:data},helper ? helper.call(depth0, "calendar.message_participants.message_label", "Message", options) : helperMissing.call(depth0, "t", "calendar.message_participants.message_label", "Message", options)))
    + "\n      <span class=\"error-text\" aria-hidden=\"true\">*</span>\n    </label><br />\n    <textarea class=\"ic-Input\" id=\"body\" name=\"body\"></textarea>\n  </div>\n  <div class=\"error\"></div>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  